import { Button, Card, Spinner } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { useCallback, useEffect } from "react";
import { MailIcon } from "@heroicons/react/outline";
import { useMutation } from "react-query";

import resentEmailVerificationMutation from "./registration/resendEmailVerificationMutation";
import { useAuth } from "../../services/wp.auth.service";
import { useNotifications } from "../../components/NotificationsContext";

const RegisterSuccess = () => {

	const { user } = useAuth();
	const { addNotification } = useNotifications();
	const navigate = useNavigate();
	const {
		isLoading,
		mutateAsync: resendVerification
	} = resentEmailVerificationMutation(useMutation);

	const handleClick = useCallback(async () => {
		try {
			await resendVerification({ id: user.databaseId });
			addNotification({
				message: "Email verification email resent. Check your inbox.",
				type: "success"
			});
		} catch (error) {
			addNotification({
				message: "Could not resend notification email.",
				type: "danger"
			});
		}
	}, []);

	useEffect(() => {
		if (user.emailVerified) {
			navigate("/");
		}
	}, [user.emailVerified]);

	return (
		<Card className="my-5">
			<Card.Body className="p-5 text-center">
				<div className="mt-4 mb-3">
					<MailIcon className="i i-4x text-green" />
				</div>

				<h3 className="text-blue mb-4">
					Check your E-mail.
				</h3>

				<p className="ms-auto me-auto" style={{ maxWidth: "400px" }}>
					You are almost registered.<br />
					Please check your email to verify your account.
				</p>

				<div className="mb-4">
					<Button
						disabled={isLoading}
						onClick={handleClick}
					>
						{ isLoading ? <Spinner animation="border" size="sm" /> : "Resend Verification Email" }
					</Button>
				</div>

				<Link to="/login">
					{"← Back to Login"}
				</Link>
			</Card.Body>
		</Card>
	);
};

export default RegisterSuccess;
